import { useCallback } from 'react';
import { UnitQueueWireDto } from '@mark43/cad-api';
import { useOpenFrEventDetails } from '../fr-event-details-page/hooks/use-open-fr-event-details';
import { FR_EVENT_DETAILS_TABS } from '../fr-event-details-page/constants';
import { FrUnitsListDrawerItem } from './fr-units-list-drawer/fr-units-list-drawer-item';
import { useViewLocationOnMap } from '../location/hooks/use-view-location-on-map';
import { EsriMapEntityTypeEnum } from '../esri/types';

export function FrUnitListItem({ unit }: { unit: UnitQueueWireDto }) {
    const openFrEventDetails = useOpenFrEventDetails();
    const viewLocationOnMap = useViewLocationOnMap();

    const openEventNarrativeTab = useCallback(() => {
        if (!unit?.eventQueueView?.id) return;
        openFrEventDetails(unit.eventQueueView.id, FR_EVENT_DETAILS_TABS.NARRATIVE);
    }, [openFrEventDetails, unit?.eventQueueView?.id]);

    const handleViewUnitOnMap = () => {
        viewLocationOnMap({
            entityId: unit.id,
            entityType: EsriMapEntityTypeEnum.UNIT,
            shouldMoveMapCenterToLoggedInUnit: false,
        });
    };

    return (
        <FrUnitsListDrawerItem
            unit={unit}
            goToEventNarrativeTab={openEventNarrativeTab}
            handleViewUnitOnMap={handleViewUnitOnMap}
        />
    );
}
